import { call, put, all, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import * as actions from './actions';
import * as types from '../types';
import axiosCoto from '../../../services/axiosCoto';
import { applyTheme } from '../../../config/themes';

function* loginRequest({ payload }) {
  try {
    const response = yield call(axiosCoto.post, '/usuario/autenticar', payload);
    if (!response.data.user.ativo) {
      toast.error('Usuário bloqueado. Favor entrar em contato com o administrador do site.');
      yield put(actions.loginFailure());
      return;
    }
    axiosCoto.defaults.headers.Authorization = `Bearer ${response.data.token}`;

    const email = get(response, 'data.user.email', payload.email);
    let corTema = 'emerald';

    if (email) {
      try {
        const temaResponse = yield call(axiosCoto.get, `/tema/${encodeURIComponent(email)}`);
        corTema = get(temaResponse, 'data.cor', 'emerald') || 'emerald';
      } catch {
        corTema = 'emerald';
      }
    }

    applyTheme(corTema);
    yield put(actions.loginSucess({ ...response.data, corTema }));
  } catch (e) {
    toast.error('Usuário ou senha inválido');
    yield put(actions.loginFailure());
  }
}

function persistRehydrate({ payload }) {
  const token = get(payload, 'auth.token');
  const corTema = get(payload, 'auth.corTema', 'emerald');
  if (!token) return;
  axiosCoto.defaults.headers.Authorization = `Bearer ${token}`;
  applyTheme(corTema);
}

export default all([
  takeLatest(types.LOGIN_REQUEST, loginRequest),
  takeLatest(types.PERSIST_REHYDRATE, persistRehydrate),
]);
